import React from 'react';


const SalesStatusCard = ({statusTitle, salesRevenue, noOfOrdersClassName, dropDown}) => {



    return (
        <section>
            <div className='order-status-card-container sales-status-card'>
                <div className='flex gap-4'>
                    {/* <div>{icon}</div> */}
                    <p className='due-text'>{statusTitle}</p>
                    <section>
                        {dropDown}
                    </section>
                </div>
                <div className='flex flex-col gap-20 mt-7'>
                    <div>
                        <p className={`no-of-orders ${noOfOrdersClassName}`}>{salesRevenue}</p>
                    </div>
                    
                </div>
                {/* <div className='customer-active-section'>
                    <p className='size mt-2'>{noOfOrders} <span className='customer-active-text'>{noOfOrders === 1 ? 'order' : 'orders'}</span> </p>
                </div> */}
            </div>
        </section>
    );
}

export default SalesStatusCard;
